import { doorCloses, doorOpens } from 'core/constants/sound';
import { isEscapeKey } from 'core/utils/keyDown';
import { getRandomItem } from 'core/utils/logic';
import { usePlaySoundEffect } from 'hooks/sound';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getIsModalOpen, setIsModalOpen } from 'reducer/modalState';

export const useNavigateHome = () => {
  const history = useHistory();
  const playSoundEffect = usePlaySoundEffect();
  return () => {
    playSoundEffect(getRandomItem(doorCloses));
    history.replace('/');
    return true;
  };
};

export const useEscapeGoesBack = () => {
  const navigateHome = useNavigateHome();
  return (e) => {
    if (isEscapeKey(e)) {
      return navigateHome();
    }
  };
};

export const useToggleModalWithSound = () => {
  const dispatch = useDispatch();
  const playSoundEffect = usePlaySoundEffect();
  const isModalOpen = useSelector(getIsModalOpen);
  return () => {
    if (isModalOpen) {
      playSoundEffect(getRandomItem(doorCloses));
      dispatch(setIsModalOpen(false));
      return true;
    }
    playSoundEffect(getRandomItem(doorOpens));
    dispatch(setIsModalOpen(true));

    return true;
  };
};
